<template>
  <img v-if="smallLogo" alt="Logo" src="@/assets/logo.svg" />
  <img v-else alt="Logo" src="@/assets/full-logo.png" />
</template>
<script>
export default {
  name: 'LogoComponent',
  props: {
    smallLogo: Boolean
  }
};
</script>
